export default {
  autocompletePaymentTerms: [],
  paymentTerms: [],
  emptyPaymentTerm: {},
  params: {
    entity: [],
    collection: []
  }
}